// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2TvcC","topBottomGutter":"Layout_topBottomGutter__1F1VI"};